import { u_ } from "@pressmedia/webappbase";

/**
 * 指定した配列データでリストを生成する関数
 *
 * @param {Array} [list]
 * @param {Function} [cb]
 * @returns this
 */
function _getSource(list, cb) {
	const isArray = Array.isArray(list);
	let page = NaN;
	
	// queryStringから生成対象のページを取得
	if( u_.hasProperty(this.module.app._GET, this.pageQuery) ) {
		page = parseInt(this.module.app._GET[this.pageQuery]);
	}
	isNaN(page) && (page = 1);
	
	if(isArray) {
		// [第一引数に配列が渡されている場合はデータを切り出す]
		
		const total = list.length;
		const offset = this.module.getOffsetLimit(page);
		u_.hasProperty(offset, "offset") || (offset.offset = 0);
		
		// データの切り出し
		if( offset.offset || u_.hasProperty(offset, "limit") ) {
			list = list.slice( offset.offset, offset.offset + (offset.limit || list.length) );
		}
		
		u_.isFunction(cb) && cb(null, list, total, offset.offset);
		
	} else {
		// [サーバーからデータをロード]
		this.module.loadItems(page, (err, res) => {
			if( u_.isString(this.module.config.fileDir) ) {
				// プリロード画像の削除
				this.module.app.clearPreloadedImg(`${this.module.config.fileDir}/img/`);
			}
			
			if( u_.isFunction(cb) ) {
				if(err) {
					cb(err, res);
					
				} else {
					list = this.module.items.list;
					const total = this.module.items.length;
					const offset = res.offset || 0;
					cb(null, list, total, offset, res);
				}
			}
		});
	}
	
	return this;
}

export default _getSource;
